<template>
    <div class="getcode">
        <div class="getcode_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
        </div>
        <div class="getcode_bottom">
            <p class="text">输入验证码</p>
            <p class="prompt">
                {{ phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2") }}
            </p>
        </div>
        <van-form class="login_form" @submit="onSubmit">
            <van-field
                class="input_code"
                v-model="code"
                type="number"
                placeholder="请填写验证码"
                maxlength="6"
                :rules="[{ required: true }]"
            >
                <span
                    style="
                        font-size: 15px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                    "
                    slot="right-icon"
                    @click="getCode"
                    :class="[keyFlag ? 'tel_code' : 'fontColor']"
                    >{{ keyFlag ? "获取验证码" : num + "秒后重新获取" }}</span
                >
            </van-field>
            <slot name="top">
                <div class="but">
                    <van-button round block type="info" native-type="submit" class="form_btn"
                        >确认注销</van-button
                    >
                </div>
            </slot>
        </van-form>
    </div>
</template>

<script>
import { Toast } from "vant";
import { Dialog } from "vant";
export default {
    name: "getcode",
    data() {
        return {
            code: "",
            keyFlag: true,
            num: 2,
            phone: "",
        };
    },
    mounted() {
        this.phone = JSON.parse(sessionStorage.getItem("userInfo")).user.username;
        this.keyFlagChange();
    },
    methods: {
        to() {
            this.$router.go(-1);
        },
        // 获取验证码
        async getCode() {
            if (!this.keyFlag) return;
            const res = await this.$apis.loginServe.getCode({
                phone: this.phone,
                adapter: "destroy",
            });
            if (res.resultCode == "200") {
                Toast("获取成功");
                this.keyFlagChange();
            } else {
                Toast(res.resultDesc);
            }
        },
        // 获取验证码时间
        keyFlagChange() {
            this.keyFlag = false;
            let timer = setInterval(() => {
                if (this.num <= 0) {
                    clearInterval(timer);
                    this.keyFlag = true;
                    this.num = 59;
                } else {
                    this.num = --this.num;
                }
            }, 1000);
        },
        // 确认是否可以注销
        async onSubmit() {
            const resp = await this.$apis.myServe.postisDestroy({
                validateCode: this.code,
            });
            if (resp.messageType === "Error") {
                Toast(resp.resultDesc);
            } else if (resp.data === false) {
                this.$router.push({
                    path: "/nologoff",
                    query: { resultDesc: resp.resultDesc },
                });
            } else if (resp.data === true) {
                Dialog.alert({
                    message:
                        "您的账号的注销申请已提交，如果提交申请后的7日之内登录过中文知识网，则账号注销请求将失效。如果没有登录过中文知识网账号将自动注销。",
                    theme: "round-button",
                }).then(() => {
                    this.postDestroy();
                });
            }
        },
        async postDestroy() {
            const resp = await this.$apis.myServe.postDestroy({});
            Toast(resp.resultDesc);
            this.logOut();
        },
        // 成功注销后退出登录
        async logOut() {
            await this.$apis.loginServe.logOut();
            this.$store.commit("clearInfo");
            this.$router.replace("my");
        },
    },
};
</script>

<style lang="scss" scoped>
.getcode {
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;
    .getcode_top {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        line-height: 44px;
    }
    .getcode_bottom {
        width: 84%;
        margin: 0 auto;
        overflow: hidden;
        .text {
            font-size: 23px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            margin-top: 42px;
        }
        .prompt {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            margin-top: 9px;
        }
    }
    .login_form {
        width: 92%;
        margin: 49px auto;
        .input_code {
            margin: 0 auto;
            width: 92%;
            border-bottom: 1px solid #dddddd;
            padding: 0px 0px 8px 0px;
            .tel_code {
                color: #4a79f1;
            }
            .fontColor {
                color: #999999;
            }
        }
        .but {
            width: 100%;
            // margin-top: 24px;
            margin: 25px auto;
            .form_btn {
                height: 40px;
                background: #4a79f1;
                border-radius: 22px;
                .van-button__text {
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #ffffff;
                }
            }
        }
    }
}
</style>
